import React from "react";
import Styles from "./Faq.module.css";
import Navigation from "../../Layout/Navigation/Navigation";
import DropDownList from "../../Layout/DropdownList/DropDownList";
const Faq = () => {
  const optionsList = [
    {
      title: "How Can I request more data?",
      text: "We provide data for thousands companies but, if you need more, feel free to request with the request button.",
    },
  ];
  return (
    <div className={Styles.Page}>
      <Navigation />
      <div className={Styles.PageContent}>
        <div className={Styles.PageTitle}>
          <h3>F.A.Q.</h3>
          <p>Our Website is designed to show latest 13G Reports.</p>
        </div>
        <DropDownList options={optionsList} />
      </div>
    </div>
  );
};

export default Faq;
